<script>
import { CdrList, CdrText, CdrLink } from '@rei/cedar';

export default {
  name: 'CategoryNav',
  components: {
    CdrList,
    CdrText,
    CdrLink,
  },
  props: {
    categoryText: { type: String, required: false, default: () => '' },
    linkCategories: { type: Array, required: true, default: () => {} },
  },
  computed: {
    renderComponent() {
      return this.linkCategories?.length;
    },
    /*
    * Filter out any categories that don't have links.
    */
    computedLinkCategories() {
      return this.linkCategories.filter((category) => category.children?.length);
    },
    srOnlyHeading() {
      return `Shop ${this.categoryText} by category`;
    },
  },
};
</script>
<template>
  <div
    v-if="renderComponent"
    class="category-nav"
  >
    <cdr-text
      tag="h2"
      class="category-nav__heading"
    >
      {{ srOnlyHeading }}
    </cdr-text>
    <div class="category-nav__links">
      <div
        v-for="(category, index) in computedLinkCategories"
        :key="index"
      >
        <div v-if="category.children && category.children.length">
          <cdr-text
            tag="h3"
          >
            <cdr-link
              :href="category.href"
              class="category-nav__category-title"
              modifier="standalone"
            >
              {{ category.text }}
            </cdr-link>
          </cdr-text>
          <cdr-list>
            <li
              v-for="(link, i) in category.children"
              :key="i"
            >
              <cdr-link
                :href="link.href"
                class="category-nav__category-links"
                modifier="standalone"
              >
                {{ link.text }}
              </cdr-link>
            </li>
          </cdr-list>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.category-nav {
  margin-top: $cdr-space-three-quarter-x;

  &__heading {
    @include cdr-display-sr-only;
  }

  &__links {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: $cdr-space-three-x;
    grid-column-gap: $cdr-space-one-and-a-half-x;

    @include cdr-sm-mq-up {
      grid-template-columns: repeat(3, 1fr);
    }

    @include cdr-md-mq-up {
      grid-template-columns: repeat(4, 1fr);
    }
  }
  &__category-title {
    @include cdr-text-heading-sans-300;
    color: $cdr-color-text-primary;
    display: block;
    margin-bottom: $cdr-space-three-quarter-x;
  }

  &__category-links {
    @include cdr-text-utility-sans-300;
    color: $cdr-color-text-primary;
    display: block;
    &:not(:last-child) {
      margin-bottom: $cdr-space-three-quarter-x;
    }
  }
  &__aside-block {
    &::before {
      content: '';
      background: url(//satchel.rei.com/media/img/ico/mega-menu-sprite.png);
      height: 40px;
      width: 40px;
      object-fit: cover;
    }
  }
}
</style>
